import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Tooltip,
  Button,
  Typography,
  Switch,
  styled,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";

const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 38,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#4CAF50", // ✅ Green when Active
        opacity: 1,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#F44336", // ✅ Red when Inactive
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
  },
}));

const UserHieTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hierarchyData, partnerName, breadcrumb = [] } = location.state || {};
  const [data, setData] = useState([]);
  const [history, setHistory] = useState([]);
  const [currentBreadcrumb, setCurrentBreadcrumb] = useState(breadcrumb);

  useEffect(() => {
    if (hierarchyData?.child) {
      setData(hierarchyData.child);
    }
  }, [hierarchyData]);

  const handleSeeHierarchy = async (row) => {
    try {
      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/auth/hierarchyFlowChart`,
        { params: { userId: row.userId } }
      );
      setHistory((prev) => [...prev, { data, breadcrumb: currentBreadcrumb }]);
      setData(response.data.body.child || []);
      setCurrentBreadcrumb((prev) => [...prev, row.userId]);
    } catch (error) {
      console.error("Error fetching hierarchy data:", error);
    }
  };

  const handleBack = () => {
    if (history.length > 0) {
      const lastState = history.pop();
      setData(lastState.data);
      setCurrentBreadcrumb(lastState.breadcrumb);
      setHistory(history);
    } else {
      navigate(-1);
    }
  };

  const toggleUserStatus = async (userId, currentStatus) => {
    const token = sessionStorage.getItem("jwtToken");
    try {
      const response = await axios.put(
        `https://api.ipaisa.co.in/myapp/admin/changeStatus/${userId}`,
        { userId }, // Sending userId in the payload
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log(response);

      setData((prev) =>
        prev.map((user) =>
          user.userId === userId
            ? {
                ...user,
                userStatus: currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE",
              }
            : user
        )
      );
    } catch (error) {
      console.error("Error changing user status:", error);
    }
  };

  const toggleHiePayoutStatus = async (userId, currentStatus) => {
    const token = sessionStorage.getItem("jwtToken");
    try {
      const requestBody = currentStatus === "INACTIVE" ? true  : ''; // 👈 Extra parameter for INACTIVE case
  
      const response = await axios.put(
        `https://api.ipaisa.co.in/myapp/admin/heirarchyPayouStatusUpdate?userId=${userId}&active=${requestBody}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
  
      console.log(response);
  
      setData((prev) =>
        prev.map((user) =>
          user.userId === userId
            ? {
                ...user,
                userPayoutHierarchyStatus:
                  currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE",
              }
            : user
        )
      );
    } catch (error) {
      console.error("Error changing payout status:", error);
    }
  };
  
  const togglePayoutStatus = async (userId, currentStatus) => {
    const token = sessionStorage.getItem("jwtToken");
    try {
      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/admin/change-payout-status/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Single Payout",response);

      setData((prev) =>
        prev.map((user) =>
          user.userId === userId
            ? {
                ...user,
                userPayoutStatus:
                  currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE",
              }
            : user
        )
      );
    } catch (error) {
      console.error("Error changing payout status:", error);
    }
  };

  return (
    <Box sx={{ padding: 3, marginTop: "5%", backgroundColor: "#F4F5FA" }}>
      <Grid sx={{ display: "flex", alignItems: "center", gap: "1%" }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ color: "white", backgroundColor: "#027BFE", width: "10%" }}
        >
          Back
        </Button>
        <Grid item>
          <Typography>
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>
              {partnerName} {" -> "}
            </span>
            <span style={{ fontSize: "14px" }}>
              {currentBreadcrumb.join(" > ")}
            </span>
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TableContainer
          component={Paper}
          sx={{
            marginTop: 2,
            borderRadius: 2,
            boxShadow: 3,
            overflowX: "auto",
          }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "#027BFE" }}>
              <TableRow>
                <TableCell sx={{ color: "white" }}>Sr No.</TableCell>
                <TableCell sx={{ color: "white" }}>Total Hierarchy Payout</TableCell>
                <TableCell sx={{ color: "white" }}>Name</TableCell>
                <TableCell sx={{ color: "white" }}>User ID</TableCell>
                <TableCell sx={{ color: "white" }}>User Role</TableCell>
                <TableCell sx={{ color: "white" }}>Business Name</TableCell>
                <TableCell sx={{ color: "white" }}>Mobile</TableCell>
                <TableCell sx={{ color: "white" }}>PayIn Service</TableCell>
                <TableCell sx={{ color: "white" }}>Wallet Balance</TableCell>
                <TableCell sx={{ color: "white" }}>Payout Services</TableCell>
                <TableCell sx={{ color: "white" }}>User Status</TableCell>
                <TableCell sx={{ color: "white" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#C1E0FB",
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <IOSSwitch
                        checked={row.userPayoutHierarchyStatus === "ACTIVE"}
                        onChange={() =>
                          toggleHiePayoutStatus(row.userId, row.userPayoutHierarchyStatus)
                        }
                      />
                    </TableCell>
                    <TableCell>{row.userName}</TableCell>
                    <TableCell>{row.userId}</TableCell>
                    <TableCell>{row.userRole}</TableCell>
                    <TableCell>{row.userBusinessName || "N/A"}</TableCell>
                    <TableCell>{row.userContactNo || "N/A"}</TableCell>
                    <TableCell>{row.userPayinStatus}</TableCell>
                    <TableCell>
                      {Number(row.userWalletBalance).toFixed(2)}
                    </TableCell>
                    <TableCell>
                      <IOSSwitch
                        checked={row.userPayoutStatus === "ACTIVE"}
                        onChange={() =>
                          togglePayoutStatus(row.userId, row.userPayoutStatus)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <IOSSwitch
                        checked={row.userStatus === "ACTIVE"}
                        onChange={() =>
                          toggleUserStatus(row.userId, row.userStatus)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <Tooltip title="See Hierarchy">
                        <IconButton
                          onClick={() => handleSeeHierarchy(row)}
                          sx={{ color: "#4CAF50" }}
                        >
                          <AccountTreeIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No Hierarchy Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Box>
  );
};

export default UserHieTable;
